/* Fashion CITY — 커스텀 후디 색상 사진 (앞면 + 뒷면)
   ★ 색을 넣거나 빼려면 아래 h('보이는 이름','파일이름조각') 줄만 고치면 됩니다.
     → fc-hood-<조각>.jpg (앞면) / fc-hood-back-<조각>.jpg (뒷면)
     뒷면 사진이 아직 없는 색은 세 번째 칸에 false 를 넣으세요. 예: h('Mint','Mint', false)
*/
window.FCPO_STYLES = window.FCPO_STYLES || {};
window.FCPO_PLACE_BY_HANDLE = window.FCPO_PLACE_BY_HANDLE || {};
(function () {
  var HANDLE = 'custom-hoodie-your-design';
  var B = 'https://cdn.shopify.com/s/files/1/0372/5544/6665/files/fc-hood-';
  function h(name, slug, hasBack) {
    var row = [name, B + slug + '.jpg'];
    if (hasBack !== false) row.push(B + 'back-' + slug + '.jpg');
    return row;
  }

  window.FCPO_STYLES[HANDLE] = {
    styleLabel: 'Style',
    colorLabel: 'Hoodie color',
    propStyle: 'Style',
    propColor: 'Hoodie color',
    styles: [
      {
        n: 'Pullover Hoodie',
        sku: '',
        colors: [
          h('Black', 'Black'),
          h('Ash Grey', 'Ash-Grey'),
          h('White', 'White'),
          h('Sand', 'Sand'),
          h('Brown', 'Brown'),
          h('Navy', 'Navy'),
          h('Indigo', 'Indigo'),
          h('Royal', 'Royal'),
          h('Light Blue', 'Light-Blue'),
          h('Purple', 'Purple'),
          h('Burgundy', 'Burgundy'),
          h('Red', 'Red'),
          h('Orange', 'Orange'),
          h('Hot Pink', 'Hot-Pink'),
          h('Light Pink', 'Light-Pink'),
          h('Forest Green', 'Forest-Green'),
          h('Kelly Green', 'Kelly-Green'),
          h('Olive', 'Olive')
        ]
      }
    ]
  };

  /* 자수/인쇄 자리 — 이 사진에 맞춰 잡았습니다.
     x, y : 사진 왼쪽 위가 0,0 / 오른쪽 아래가 100,100 (y 가 클수록 아래)
     w    : Medium 일 때 폭 (사진 가로폭의 %)
     view : 'back' 이면 뒷면 사진으로 바뀝니다
     ※ 앞판 인쇄는 앞주머니에 안 걸리게 가슴 쪽으로 올려 뒀습니다.
     ※ 소매(Sleeve) 자리는 뺐습니다. 다시 쓰려면 아래 한 줄을 추가하세요.
       { v: 'Sleeve', x: 15, y: 50, w: 9, sizes: [1.5, 2, 3] }
  */
  window.FCPO_PLACE_BY_HANDLE[HANDLE] = [
    { v: 'Left chest', x: 37, y: 33, w: 13, sizes: [3, 4, 5] },
    { v: 'Full front', x: 50, y: 42, w: 34, sizes: [11, 12, 13] },
    { v: 'Full back',  x: 50, y: 40, w: 34, sizes: [11, 12, 13], view: 'back' }
  ];
})();